module.exports = __webpack_public_path__ + "img/news_pack.e63e061e.svg";